export default {
  ledger: "profile/ledger",
  invoice: (no) => `billing/proforma/${no}`,
  receipt: (no) => `billing/receipt/${no}`,
  balance: `billing/balance`,
  verifyPayment: (ref) => `billing/verify-payment/${ref}`,
};
